import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import { Breadcrumb } from 'react-bootstrap';

class CommonPageHeader extends Component{

    render = () => {
        const object = this.props.object;
        const { onBreadcrumbClick, backward, forward } = this.props;

        return (
            <div className="hk-pg-header">
                <div className="d-flex align-items-center">
                    {object?.icon && (
                        <div className="avatar avatar-icon avatar-sm avatar-primary avatar-rounded me-3" >
                            <span className="initial-wrap">
                                <span className="feather-icon">
                                    <i className={object.icon} />
                                </span>
                            </span>
                        </div>
                    )}
                    <div className="d-flex flex-wrap justify-content-between flex-1 align-items-center">
                        <div className="mb-md-0 mb-2 me-8">
                            <h4 className="mb-0">{object.title}</h4>
                        </div>

                        <div className="mb-md-0 mb-2 me-0">
                            <nav aria-label="breadcrumb">
                                <div className="mb-md-0 mb-2 me-8">
                                    <Breadcrumb>
                                        {object.breadcrumbs.map((breadcrumb, index) => {
                                            const callbackFunction =
                                            breadcrumb.onClick === "backward"
                                                ? backward
                                                : breadcrumb.onClick === "forward"
                                                ? forward
                                                : breadcrumb.onClick;
                                            return (
                                                <Breadcrumb.Item
                                                    key={index}
                                                    linkAs={breadcrumb.path ? Link : "span"} 
                                                    linkProps={breadcrumb.path ? { 
                                                        to: `${breadcrumb.path}${breadcrumb.parameters?.length ? '?' + breadcrumb.parameters.map(param => `${param.name}=${param.value}`).join('&') : ''}`
                                                    } : {}}
                                                    active={!breadcrumb.path} 
                                                    onClick={
                                                        callbackFunction
                                                            ? () => onBreadcrumbClick(callbackFunction)
                                                            : undefined
                                                    } 
                                                    style={breadcrumb.onClick ? { cursor: "pointer" } : {}}
                                                >
                                                    {breadcrumb.label}
                                                </Breadcrumb.Item>
                                            )}
                                        )}
                                    </Breadcrumb>
                                </div>
                            </nav>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default CommonPageHeader;